import React from 'react';
import { Route, RouteProps } from 'react-router-dom';

// components
import PrivateRoute from './PrivateRoute';
import Root from './Root';

// lazy load all the views

// auth
const Login = React.lazy(() => import('../pages/auth/Login'));
const Logout = React.lazy(() => import('../pages/auth/Logout'));
const MyAccount = React.lazy(() => import('../pages/auth/MyAccount'));
const Confirm = React.lazy(() => import('../pages/auth/Confirm'));
const ForgetPassword = React.lazy(() => import('../pages/auth/ForgetPassword'));
const Register = React.lazy(() => import('../pages/auth/Register'));
const LockScreen = React.lazy(() => import('../pages/auth/LockScreen'));
const ResetOtp = React.lazy(() => import('../pages/auth/ResetPasswordOtp'));

// Admin
const OverViewAdmin = React.lazy(() => import('../pages/admin/OverViewAdmin'));
const InvoiceAdmin = React.lazy(() => import('../pages/admin/InvoiceAdmin'));
const PurChaseCreditsAdmin = React.lazy(() => import('../pages/admin/PurChaseCreditsAdmin'));
const ApiUsageAdmin = React.lazy(() => import('../pages/admin/ApiUsageAdmin'));

// landing
const Landing = React.lazy(() => import('../pages/landing/'));
const Home = React.lazy(() => import('../pages/web/home'));
const Fquestions = React.lazy(() => import('../pages/web/Fquestions'));
const About = React.lazy(() => import('../pages/web/About'));
const OurServices = React.lazy(() => import('../pages/web/Our_Services'));
const PdfImgConverter = React.lazy(() => import('../pages/web/PdfImgConverter'));
const PrivacyPolicy = React.lazy(() => import('../pages/web/PrivacyPolicy'));
const GdprCompliance = React.lazy(() => import('../pages/web/GdprCompliance'));
const DataProcessingArgeement = React.lazy(() => import('../pages/web/DataProcessingArgeement'));
const TermsOfService = React.lazy(() => import('../pages/web/TermsOfService'));
const PasswordUpdateUser = React.lazy(() => import('../pages/web/PasswordUpdateUser'));
const ErrorList = React.lazy(() => import('../pages/web/ErrorList'));

const Contact = React.lazy(() => import('../pages/web/ContactUs'));
const Converts = React.lazy(() => import('../pages/web/Converts'));
const IpWhitelisting = React.lazy(() => import('../pages/web/IpWhitelisting'));

//tools
const HtmlfileToPdf = React.lazy(() => import('../pages/tools/HtmlfileToPdf'));
const TextFileToPdf = React.lazy(() => import('../pages/tools/TextFileToPdf'));
const WatermarkPdf = React.lazy(() => import('../pages/tools/WatermarkPdf'));
const SplitPdf = React.lazy(() => import('../pages/tools/SplitPdf'));
const PageNumberPdf = React.lazy(() => import('../pages/tools/PageNumberPdf'));
const RotatePdf = React.lazy(() => import('../pages/tools/RotatePdf'));
const ExtractPdf = React.lazy(() => import('../pages/tools/ExtractPdf'));
const TextToPdf = React.lazy(() => import('../pages/tools/TextToPdf'));
const HtmlToPdf = React.lazy(() => import('../pages/tools/HtmlToPdf'));


//services
const WaterMarkPdfService = React.lazy(() => import('../pages/service/WaterMarkPdfService'));
const ExtractPdfService = React.lazy(() => import('../pages/service/ExtractPdfService'));
const RotatePdfService = React.lazy(() => import('../pages/service/RotatePdfService'));
const SplitPdfService = React.lazy(() => import('../pages/service/SplitPdfService'));
const HtmltoPdfService = React.lazy(() => import('../pages/service/HtmltoPdfService'));
const TextPdfService = React.lazy(() => import('../pages/service/TextPdfService'));
const PageNumberPdfService = React.lazy(() => import('../pages/service/PageNumberPdfService'));
const TextFileToPdfService = React.lazy(() => import('../pages/service/TextFileToPdfService'));
const HtmlFileToPdfService = React.lazy(() => import('../pages/service/HtmlFileToPdfService'));

// dashboard
const EcommerceDashboard = React.lazy(() => import('../pages/dashboard/Ecommerce/'));
const AnalyticsDashboard = React.lazy(() => import('../pages/dashboard/Analytics/'));

// apps
const CalendarApp = React.lazy(() => import('../pages/apps/Calendar/'));
const Projects = React.lazy(() => import('../pages/apps/Projects/'));
const ProjectDetail = React.lazy(() => import('../pages/apps/Projects/Detail/'));

//credentials
const CreateApi = React.lazy(() => import('../pages/apps/Credentials/CreateApi'));

//Overview
const ChangePassword = React.lazy(() => import('../pages/profile/ChangePassword'));
const ProfileUpdate = React.lazy(() => import('../pages/profile/ProfileUpdate'));
const LicenseInformation = React.lazy(() => import('../pages/profile/LicenseInformation'));
const OverView = React.lazy(() => import('../pages/profile/OverView'));
const InvoiceListFile = React.lazy(() => import('../pages/profile/InvoiceList'));
const InvoiceBill = React.lazy(() => import('../pages/profile/InvoiceBill'));
const ApiList = React.lazy(() => import('../pages/profile/ApiList'));
const ApiUsage = React.lazy(() => import('../pages/profile/ApiUsage'));

// - chat
const ChatApp = React.lazy(() => import('../pages/apps/Chat/'));

// - email
const Inbox = React.lazy(() => import('../pages/apps/Email/Inbox'));
const EmailDetail = React.lazy(() => import('../pages/apps/Email/Detail'));
const EmailCompose = React.lazy(() => import('../pages/apps/Email/Compose'));

// - tasks
const TaskList = React.lazy(() => import('../pages/apps/Tasks/List/'));
const Kanban = React.lazy(() => import('../pages/apps/Tasks/Board/'));

// - file
const FileManager = React.lazy(() => import('../pages/apps/FileManager'));

// extra pages
const Error404 = React.lazy(() => import('../pages/error/Error404'));
const Error500 = React.lazy(() => import('../pages/error/Error500'));

// -other
const Starter = React.lazy(() => import('../pages/other/Starter'));
const Profile = React.lazy(() => import('../pages/other/Profile'));
const Activity = React.lazy(() => import('../pages/other/Activity'));
const Invoice = React.lazy(() => import('../pages/other/Invoice'));
const Maintenance = React.lazy(() => import('../pages/other/Maintenance'));
const Pricing = React.lazy(() => import('../pages/other/Pricing'));

// uikit
const UIElements = React.lazy(() => import('../pages/uikit'));

// widgets
const Widgets = React.lazy(() => import('../pages/widgets/'));

// icons
const Unicons = React.lazy(() => import('../pages/icons/Unicons'));
const FeatherIcons = React.lazy(() => import('../pages/icons/Feather/'));
const BootstrapIcon = React.lazy(() => import('../pages/icons/Bootstrap/'));

// forms
const BasicForms = React.lazy(() => import('../pages/forms/Basic'));
const FormAdvanced = React.lazy(() => import('../pages/forms/Advanced'));
const FormValidation = React.lazy(() => import('../pages/forms/Validation'));
const FormWizard = React.lazy(() => import('../pages/forms/Wizard'));
const FileUpload = React.lazy(() => import('../pages/forms/FileUpload'));
const Editors = React.lazy(() => import('../pages/forms/Editors'));

// charts
const Charts = React.lazy(() => import('../pages/charts/'));

// tables
const BasicTables = React.lazy(() => import('../pages/tables/Basic'));
const AdvancedTables = React.lazy(() => import('../pages/tables/Advanced'));

// maps
const GoogleMaps = React.lazy(() => import('../pages/maps/GoogleMaps'));
const VectorMaps = React.lazy(() => import('../pages/maps/VectorMaps'));

export interface RoutesProps {
    path: RouteProps['path'];
    name?: string;
    component?: RouteProps['component'];
    route?: any;
    exact?: RouteProps['exact'];
    icon?: string;
    header?: string;
    roles?: string[];
    children?: RoutesProps[];
}

// root routes
const rootRoute: RoutesProps = {
    path: '/',
    exact: true,
    component: () => <Root />,
    route: Route,
};

// dashboards
const dashboardRoutes: RoutesProps = {
    path: '/dashboard',
    name: 'Dashboards',
    icon: 'airplay',
    header: 'Navigation',
    children: [
        {
            path: '/dashboard/ecommerce',
            name: 'Ecommerce',
            component: EcommerceDashboard,
            route: PrivateRoute,
        },
        {
            path: '/dashboard/analytics',
            name: 'Analytics',
            component: AnalyticsDashboard,
            route: PrivateRoute,
        },
    ],
};

const calendarAppRoutes: RoutesProps = {
    path: '/apps/calendar',
    name: 'Calendar',
    route: PrivateRoute,
    roles: ['Admin'],
    icon: 'calendar',
    children: [
        {
            path: '/apps/calendar',
            name: 'Inbox',
            component: CalendarApp,
            route: PrivateRoute,
        },
    ],
};

const ChangePasswordAppRoutes: RoutesProps = {
    path: '/profile/change_password',
    name: 'Change Password',
    route: PrivateRoute,
    roles: ['Admin'],
    icon: 'shield',
    children: [
        {
            path: '/profile/change_password',
            name: 'Change Password',
            component: ChangePassword,
            route: PrivateRoute,
        },
    ],
};

const OverViewAppRoutes: RoutesProps = {
    path: '/profile/overview',
    name: 'Over View',
    route: PrivateRoute,
    roles: ['Admin'],
    icon: 'shield',
    children: [
        {
            path: '/profile/overview',
            name: 'Over View',
            component: OverView,
            route: PrivateRoute,
        },
        {
            path: '/ip_whitelisting',
            name: 'IpWhitelisting',
            component: IpWhitelisting,
            route: PrivateRoute,
        },
    ],
};


const AdminAppRoutes: RoutesProps = {
    path: '/admin',
    name: 'OverView Admin',
    route: PrivateRoute,
    roles: ['Admin'],
    icon: 'shield',
    children: [
        {
            path: '/admin/overview',
            name: 'OverView Admin',
            component: OverViewAdmin,
            route: PrivateRoute,
        },
        {
            path: '/admin/purchase_credits',
            name: 'Purchase Credits',
            component: PurChaseCreditsAdmin,
            route: PrivateRoute,
        },
        {
            path: '/admin/invoice',
            name: 'Invoice Admin',
            component: InvoiceAdmin,
            route: PrivateRoute,
        },
        {
            path: '/admin/usage',
            name: 'ApiUsage Admin',
            component: ApiUsageAdmin,
            route: PrivateRoute,
        }
    ],
};


const ProfileRoutes: RoutesProps = {
    path: '/profile/profile_update',
    name: 'Profile',
    route: PrivateRoute,
    roles: ['Admin'],
    icon: 'shield',
    children: [
        {
            path: '/profile/profile_update',
            name: 'Profile',
            component: ProfileUpdate,
            route: PrivateRoute,
        },
    ],
};

const LicenseInformationRoutes: RoutesProps = {
    path: '/profile/license_information',
    name: 'Profile',
    route: PrivateRoute,
    roles: ['Admin'],
    icon: 'shield',
    children: [
        {
            path: '/profile/license_information',
            name: 'Profile',
            component: LicenseInformation,
            route: PrivateRoute,
        },
    ],
};



const InvoiceList: RoutesProps = {
    path: '/invoice_list',
    name: 'Invoice List',
    route: PrivateRoute,
    roles: ['Admin'],
    icon: 'shield',
    children: [
        {
            path: '/invoice_list',
            name: 'Profile',
            component: InvoiceListFile,
            route: PrivateRoute,
        },
    ],
};

const credenitalsAppRoutes: RoutesProps = {
    path: '/apps/credentials',
    name: 'credentials',
    route: PrivateRoute,
    roles: ['Admin'],
    icon: 'mail',
    children: [
        {
            path: '/apps/credentials/create',
            name: 'Api Create',
            component: CreateApi,
            route: PrivateRoute,
        },
        {
            path: '/api/list',
            name: 'Api Lists',
            component: ApiList,
            route: PrivateRoute,
        },
    ],
};



const chatAppRoutes: RoutesProps = {
    path: '/apps/chat',
    name: 'Chat',
    route: PrivateRoute,
    roles: ['Admin'],
    icon: 'message-square',
    children: [
        {
            path: '/apps/chat',
            name: 'Inbox',
            component: ChatApp,
            route: PrivateRoute,
        },
    ],
};

const emailAppRoutes: RoutesProps = {
    path: '/apps/email',
    name: 'Email',
    route: PrivateRoute,
    roles: ['Admin'],
    icon: 'mail',
    children: [
        {
            path: '/apps/email/inbox',
            name: 'Inbox',
            component: Inbox,
            route: PrivateRoute,
        },
        {
            path: '/apps/email/details',
            name: 'Email Details',
            component: EmailDetail,
            route: PrivateRoute,
        },
        {
            path: '/apps/email/compose',
            name: 'Compose Email',
            component: EmailCompose,
            route: PrivateRoute,
        },
    ],
};

const projectAppRoutes: RoutesProps = {
    path: '/apps/projects',
    name: 'Projects',
    route: PrivateRoute,
    roles: ['Admin'],
    icon: 'uil-briefcase',

    children: [
        {
            path: '/apps/projects/list',
            name: 'List',
            component: Projects,
            route: PrivateRoute,
        },
        {
            path: '/apps/projects/details',
            name: 'Detail',
            component: ProjectDetail,
            route: PrivateRoute,
        },
    ],
};

const taskAppRoutes: RoutesProps = {
    path: '/apps/tasks',
    name: 'Tasks',
    route: PrivateRoute,
    roles: ['Admin'],
    icon: 'clipboard',
    children: [
        {
            path: '/apps/tasks/list',
            name: 'Task List',
            component: TaskList,
            route: PrivateRoute,
        },
        {
            path: '/apps/tasks/kanban',
            name: 'Kanban',
            component: Kanban,
            route: PrivateRoute,
        },
    ],
};

const fileAppRoutes: RoutesProps = {
    path: '/apps/file-manager',
    name: 'File Manager',
    route: PrivateRoute,
    roles: ['Admin'],
    icon: 'folder-plus',
    component: FileManager,
};

const appRoutes = [AdminAppRoutes, calendarAppRoutes, InvoiceList, ProfileRoutes, OverViewAppRoutes, LicenseInformationRoutes, ChangePasswordAppRoutes, credenitalsAppRoutes, chatAppRoutes, emailAppRoutes, projectAppRoutes, taskAppRoutes, fileAppRoutes];

// pages
const extrapagesRoutes: RoutesProps = {
    path: '/pages',
    name: 'Pages',
    icon: 'package',
    header: 'Custom',
    children: [
        {
            path: '/pages/starter',
            name: 'Starter',
            component: Starter,
            route: PrivateRoute,
        },
        {
            path: '/pages/profile',
            name: 'Profile',
            component: Profile,
            route: PrivateRoute,
        },
        {
            path: '/pages/activity',
            name: 'Activity',
            component: Activity,
            route: PrivateRoute,
        },
        {
            path: '/pages/invoice',
            name: 'Invoice',
            component: Invoice,
            route: PrivateRoute,
        },
        {
            path: '/pages/pricing',
            name: 'Pricing',
            component: Pricing,
            route: PrivateRoute,
        },
    ],
};

// ui
const uiRoutes: RoutesProps = {
    path: '/components',
    name: 'Components',
    icon: 'package',
    header: 'UI Elements',
    children: [
        {
            path: '/components/ui-elements',
            name: 'UIElements',
            component: UIElements,
            route: PrivateRoute,
        },
        {
            path: '/components/widgets',
            name: 'Widgets',
            component: Widgets,
            route: PrivateRoute,
        },
        {
            path: '/icons',
            name: 'Icons',
            children: [
                {
                    path: '/icons/unicons',
                    name: 'Unicons',
                    component: Unicons,
                    route: PrivateRoute,
                },
                {
                    path: '/icons/feather',
                    name: 'Feather',
                    component: FeatherIcons,
                    route: PrivateRoute,
                },
                {
                    path: '/icons/bootstrap',
                    name: 'Bootstrap Icon',
                    component: BootstrapIcon,
                    route: PrivateRoute,
                },
            ],
        },
        {
            path: '/forms',
            name: 'Forms',
            children: [
                {
                    path: '/forms/basic',
                    name: 'Basic Elements',
                    component: BasicForms,
                    route: PrivateRoute,
                },
                {
                    path: '/forms/advanced',
                    name: 'Form Advanced',
                    component: FormAdvanced,
                    route: PrivateRoute,
                },
                {
                    path: '/forms/validation',
                    name: 'Form Validation',
                    component: FormValidation,
                    route: PrivateRoute,
                },
                {
                    path: '/forms/wizard',
                    name: 'Form Wizard',
                    component: FormWizard,
                    route: PrivateRoute,
                },
                {
                    path: '/forms/upload',
                    name: 'File Upload',
                    component: FileUpload,
                    route: PrivateRoute,
                },
                {
                    path: '/forms/editors',
                    name: 'Editors',
                    component: Editors,
                    route: PrivateRoute,
                },
            ],
        },
        {
            path: '/components/charts',
            name: 'Charts',
            component: Charts,
            route: PrivateRoute,
        },
        {
            path: '/tables',
            name: 'Tables',
            children: [
                {
                    path: '/tables/basic',
                    name: 'Basic',
                    component: BasicTables,
                    route: PrivateRoute,
                },
                {
                    path: '/tables/advanced',
                    name: 'Advanced',
                    component: AdvancedTables,
                    route: PrivateRoute,
                },
            ],
        },
        {
            path: '/maps',
            name: 'Maps',
            children: [
                {
                    path: '/maps/googlemaps',
                    name: 'Google Maps',
                    component: GoogleMaps,
                    route: PrivateRoute,
                },
                {
                    path: '/maps/vectorMaps',
                    name: 'Google Maps',
                    component: VectorMaps,
                    route: PrivateRoute,
                },
            ],
        },
    ],
};

// auth
const authRoutes: RoutesProps[] = [
    {
        path: '/auth/login',
        name: 'Login',
        component: Login,
        route: Route,
    },
    {
        path: '/auth/register',
        name: 'Register',
        component: Register,
        route: Route,
    },
    {
        path: '/auth/confirm',
        name: 'Confirm',
        component: Confirm,
        route: Route,
    },
    {
        path: '/auth/forget-password',
        name: 'Forget Password',
        component: ForgetPassword,
        route: Route,
    },
    {
        path: '/auth/lock-screen',
        name: 'Lock Screen',
        component: LockScreen,
        route: Route,
    },
    {
        path: '/auth/logout',
        name: 'Logout',
        component: Logout,
        route: Route,
    },
    {
        path: 'my_account',
        name: 'MyAccount',
        component: MyAccount,
        route: Route,
    },
];

// public routes 
const otherPublicRoutes: RoutesProps[] = [
    {
        path: '/landing',
        name: 'landing',
        component: Landing,
        route: Route,
    },
    {
        path: '/invoice_bill/:id',
        name: 'invoiceBill',
        component: InvoiceBill,
        route: Route,
    },
    {
        path: '/api/usage',
        name: 'Api Usage',
        component: ApiUsage,
        route: Route,
    },

    {
        path: '/home',
        name: 'home',
        component: Home,
        route: Route,
    },
    {
        path: '/about',
        name: 'about',
        component: About,
        route: Route,
    },
    {
        path: '/frequently_questions',
        name: 'Fquestions',
        component: Fquestions,
        route: Route,
    },
    {
        path: '/text_to_pdf',
        name: 'TextToPdf',
        component: TextToPdf,
        route: Route,
    },
    {
        path: '/html_to_pdf',
        name: 'HtmlToPdf',
        component: HtmlToPdf,
        route: Route,
    },
    {
        path: '/password_update_user',
        name: 'PasswordUpdateUser',
        component: PasswordUpdateUser,
        route: Route,
    },
    {
        path: '/converts',
        name: 'converts',
        component: Converts,
        route: Route,
    },
    {
        path: '/html_file_to_pdf',
        name: 'HtmlToPdf',
        component: HtmlfileToPdf,
        route: Route,
    },
    {
        path: '/text_file_to_pdf',
        name: 'TextToPdf',
        component: TextFileToPdf,
        route: Route,
    },
    {
        path: '/watermark_pdf',
        name: 'WaterMarkToPdf',
        component: WatermarkPdf,
        route: Route,
    },
    {
        path: '/watermark_pdf_service',
        name: 'WaterMarkPdfService',
        component: WaterMarkPdfService,
        route: Route,
    },
    {
        path: '/text_pdf_service',
        name: 'TextPdfService',
        component: TextPdfService,
        route: Route,
    },
    {
        path: '/pagenumber_pdf_service',
        name: 'PageNumberPdfService',
        component: PageNumberPdfService,
        route: Route,
    },
    {
        path: '/split_pdf',
        name: 'SplitPdf',
        component: SplitPdf,
        route: Route,
    },
    {
        path: '/rotate_pdf',
        name: 'RotatePdf',
        component: RotatePdf,
        route: Route,
    },
    {
        path: '/extract_pdf',
        name: 'ExtractPdf',
        component: ExtractPdf,
        route: Route,
    },
    {
        path: '/pagenumber_pdf',
        name: 'PageNumberPdf',
        component: PageNumberPdf,
        route: Route,
    },
    {
        path: '/error_list',
        name: 'ErrorList',
        component: ErrorList,
        route: Route,
    },
    {
        path: '/extract_pdf_service',
        name: 'ExtractPdf',
        component: ExtractPdfService,
        route: Route,
    },
    {
        path: '/split_pdf_service',
        name: 'SplitPdfService',
        component: SplitPdfService,
        route: Route,
    },
    {
        path: '/rotate_pdf_service',
        name: 'RotatePdfService',
        component: RotatePdfService,
        route: Route,
    },
    {
        path: '/our_services',
        name: 'OurServices',
        component: OurServices,
        route: Route,
    },
    {
        path: '/pdf_image_converter',
        name: 'pdf_image_converter',
        component: PdfImgConverter,
        route: Route,
    },
    {
        path: '/html_pdf_service',
        name: 'HtmltoPdfService',
        component: HtmltoPdfService,
        route: Route,
    },
    {
        path: '/html_file_pdf_service',
        name: 'HtmlFileToPdfService',
        component: HtmlFileToPdfService,
        route: Route,
    },
    {
        path: '/text_file_pdf_service',
        name: 'TextFileToPdfService',
        component: TextFileToPdfService,
        route: Route,
    },
    {
        path: '/contactus',
        name: 'contact',
        component: Contact,
        route: Route,
    },
    {
        path: '/privacy_policy',
        name: 'privacy_policy',
        component: PrivacyPolicy,
        route: Route,
    },
    {
        path: '/gdpr_compliance',
        name: 'gdpr_compliance',
        component: GdprCompliance,
        route: Route,
    },
    {
        path: '/data_processing_argeement',
        name: 'data_processing_argeement',
        component: DataProcessingArgeement,
        route: Route,
    },
    {
        path: '/terms_of_service',
        name: 'terms_of_service',
        component: TermsOfService,
        route: Route,
    },
    {
        path: '/maintenance',
        name: 'Maintenance',
        component: Maintenance,
        route: Route,
    },
    {
        path: '/resetotp',
        name: 'resetotp',
        component: ResetOtp,
        route: Route,
    },
    {
        path: '/error-404',
        name: 'Error - 404',
        component: Error404,
        route: Route,
    },
    {
        path: '/error-500',
        name: 'Error - 500',
        component: Error500,
        route: Route,
    },
];

// flatten the list of all nested routes
const flattenRoutes = (routes: RoutesProps[]) => {
    let flatRoutes: RoutesProps[] = [];

    routes = routes || [];
    routes.forEach((item: RoutesProps) => {
        flatRoutes.push(item);

        if (typeof item.children !== 'undefined') {
            flatRoutes = [...flatRoutes, ...flattenRoutes(item.children)];
        }
    });
    return flatRoutes;
};


const authProtectedRoutes = [rootRoute, dashboardRoutes, ...appRoutes, extrapagesRoutes, uiRoutes];
const publicRoutes = [...authRoutes, ...otherPublicRoutes];

const authProtectedFlattenRoutes = flattenRoutes([...authProtectedRoutes]);
const publicProtectedFlattenRoutes = flattenRoutes([...publicRoutes]);
export { publicRoutes, authProtectedRoutes, authProtectedFlattenRoutes, publicProtectedFlattenRoutes };
